"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var gateway_client_key_serialiser_1 = require("./../../services/gateway-control/gateway-client-key-serialiser");
/**
 * Serialiser for {@link GatewayClientList}
 */
var GatewayClientListSerialiserClass = /** @class */ (function (_super) {
    __extends(GatewayClientListSerialiserClass, _super);
    function GatewayClientListSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link GatewayClientList} from the stream
     *
     * @param bis the input stream
     * @return    the {@link GatewayClientList} that was read
     */
    GatewayClientListSerialiserClass.prototype.read = function (bis) {
        return {
            clients: Codec.readCollection(bis, gateway_client_key_serialiser_1.GatewayClientKeySerialiser.read)
        };
    };
    return GatewayClientListSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.GatewayClientListSerialiserClass = GatewayClientListSerialiserClass;
/**
 * The {@link GatewayClientListSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.GatewayClientListSerialiser = new GatewayClientListSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/gateway-client-list-serialiser.js
// module id = 1913
// module chunks = 1